// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '@/assets/style/base.css'
import config from '@/config'
import axios from 'axios'
Vue.prototype.$http = axios

Vue.config.productionTip = false
Vue.prototype.$config = config
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js